import { Suspense } from "react";
import ErrorBoundary from "../ErrorBoundary/component";

const SuspensefulErrorBoundary = ({
    suspenseProps = {},
    errorBoundaryProps = {},
    children,
} = {}) => {
    return (
        <ErrorBoundary {...errorBoundaryProps}>
            <Suspense {...suspenseProps}>{children}</Suspense>
        </ErrorBoundary>
    );
};

export const withSuspensefulErrorBoundary =
    (Component, { suspenseProps = {}, errorBoundaryProps = {} } = {}) =>
    (props) =>
        (
            <SuspensefulErrorBoundary
                suspenseProps={suspenseProps}
                errorBoundaryProps={errorBoundaryProps}
            >
                <Component {...props} />
            </SuspensefulErrorBoundary>
        );

export default SuspensefulErrorBoundary;
